import { render, staticRenderFns } from "./ThankYouBio.vue?vue&type=template&id=1eadbd3f&scoped=true&"
import script from "./ThankYouBio.vue?vue&type=script&lang=ts&"
export * from "./ThankYouBio.vue?vue&type=script&lang=ts&"
import style0 from "./ThankYouBio.vue?vue&type=style&index=0&id=1eadbd3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eadbd3f",
  null
  
)

export default component.exports